import { Trans, useTranslation } from 'react-i18next';
import get from 'lodash/get';
import {
  Box,
  Flex,
  Heading,
  Button,
  Text,
  Link,
  Divider,
  VisuallyHidden,
} from '@chakra-ui/react';

import { customerServicePhone, UFL_DOMAIN_EXT } from 'utils';
// import { useAppDispatch } from 'store/configureStore';
// import { toggleCookieBanner } from 'actions/cookieActions';
import LanguageSwitcher from 'components/LanguageSwitcher';
import UlfLayoutContainer from 'components/UlfLayoutContainer';
import { useAppSelector } from 'store/configureStore';
import { selectCurrentLocation } from 'slices/app';
import FontAwesomeIcon from './primatives/FontAwesomeIcon';
import { faExternalLink } from '@fortawesome/pro-regular-svg-icons';

const Footer = () => {
  const { t } = useTranslation();
  const currentLocation = useAppSelector(selectCurrentLocation);
  // const dispatch = useAppDispatch();
  // const isCookieBannerVisible = useSelector(
  //   (state: RootState) => state.app.cookieBannerVisible,
  // ) as boolean;

  const canada = UFL_DOMAIN_EXT === 'ca';
  const d = new Date();
  const year = d.getFullYear();
  const address = canada
    ? '2275 Upper Middle Road, Suite 200, Oakville, ON L6H 0C3'
    : '3400 Belle Chase Way, Lansing, MI 48911';
  const content = {
    questions: t(`Have a question? We're here to help.`),
    customerService: customerServicePhone,
    customerServiceARIA: t(`Call Customer Service {{ phone }}.`, {
      phone: canada ? '8 6 6. 6 8 4. 6 4 4 8' : '8 0 0. 3 4 5. 1 0 7 0',
    }),
    findLocation: canada ? '866.684.6448' : '877.720.0411',
    // findLocationARIA: t(`Call to Find a Location {{ phone }}.)`, {
    //   phone: canada ? '8 6 6. 6 8 4. 6 4 4 8' : '8 7 7. 7 2 0. 0 4 1 1',
    // }),
    copyright: `${t(
      'Copyright',
    )} ${year} TWO MEN AND A TRUCK®/International, ${address}`,
    contact: `https://twomenandatruck.${canada ? 'ca' : 'com'}/${
      canada ? 'about-us/contact-us' : 'contact'
    }`,
    privacy: `https://twomenandatruck.${canada ? 'ca' : 'com'}/privacy-policy`,
  };

  const findLocationPhoneFallback = canada ? '866.684.6448' : '877.720.0411';
  const findLocationPhone = get(
    currentLocation || {},
    'phone.organic',
    findLocationPhoneFallback,
  );

  // const optionsCountry = [
  //   { value: 'United States', label: 'United States' },
  //   { value: 'Canada', label: 'Canada' },
  //   { value: 'United Kingdom', label: 'United Kingdom' },
  //   { value: 'Ireland', label: 'Ireland' }
  // ]

  // const optionsLanguage = [
  //   { value: 'English', label: 'English', selectedState: true },
  //   { value: 'Espanol', label: 'Español' }
  // ]

  return (
    <>
      <Flex
        as="footer"
        // id="footer"
        // className="App-footer footer"
        // marginBottom={
        //   (isCookieBannerVisible &&
        //     document.getElementById('cc-banner') &&
        //     `${document.getElementById('cc-banner')?.clientHeight}px`) ||
        //   undefined
        // }
        direction="column"
        bg="tmtBlack"
        color="white"
        textAlign={{ base: 'left', md: 'inherit' }}
      >
        <UlfLayoutContainer px={{ base: 4, md: 8 }}>
          <Flex
            justify={{ base: 'flex-start', md: 'space-between' }}
            align="center"
            py={8}
            wrap="wrap"
            rowGap={2}
            columnGap={8}
          >
            <Heading
              as="h2"
              fontSize="1.5rem"
              color="#fff"
              w={{ base: '100%', lg: 'auto' }}
            >
              {content.questions}
            </Heading>
            <Flex
              columnGap={8}
              justify="flex-start"
              w={{ base: '100%', md: 'auto' }}
            >
              <Flex direction="column">
                <Box fontWeight="bold" as="span">
                  <Trans>Call Customer Service:</Trans>
                </Box>
                <Link
                  href={`tel:${content.customerService}`}
                  className="noSwap"
                  variant="footerLink"
                  color="#fff"
                >
                  {content.customerService}
                </Link>
              </Flex>
              <Flex direction="column">
                <Box as="span" fontWeight="bold">
                  {currentLocation ? (
                    <Trans>Call Now:</Trans>
                  ) : (
                    <Trans>Call to Find a Location:</Trans>
                  )}
                </Box>
                <Link
                  href={`tel:${findLocationPhone}`}
                  variant="footerLink"
                  color="#fff"
                >
                  {findLocationPhone}
                </Link>
              </Flex>
            </Flex>
            <Button
              as={Link}
              href={content.contact}
              target="_blank"
              rel="noopener noreferrer"
              w="auto"
              variant="orange"
              _focus={{ outlineColor: 'tmtGold' }}
            >
              <Trans>Contact Us</Trans>
            </Button>
          </Flex>
        </UlfLayoutContainer>
        <Box>
          <UlfLayoutContainer px={{ base: 4, md: 8 }}>
            <Divider borderColor="gray.900" />
            <Flex
              columnGap={8}
              rowGap={4}
              py={8}
              px={0}
              direction={{ base: 'column', md: 'row' }}
              justifyContent={{ base: 'center', md: 'space-between' }}
              align="flex-end"
              fontSize="sm"
              color="gray.400"
            >
              <Flex direction="column" alignItems="flex-start" gap={4} px={0}>
                <LanguageSwitcher />
                <Text>{content.copyright}</Text>
              </Flex>
              <Box textAlign={{ base: 'left', md: 'right' }}>
                <Link
                  href="https://www.servicemaster.com/our-brands/"
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="footerLink"
                  alignSelf={{ base: 'flex-start', md: 'flex-start' }}
                >
                  <Trans>A ServiceMaster Company®</Trans>
                  <VisuallyHidden>
                    <Trans>(opens in a new window)</Trans>
                  </VisuallyHidden>
                </Link>
                <Text
                  mt={2}
                  mb={0}
                  display="flex"
                  flexWrap="wrap"
                  alignItems="center"
                  justifyContent={{ base: 'flex-start', md: 'flex-end' }}
                  columnGap={{ base: 4, md: 5 }}
                  rowGap={2}
                >
                  <Link
                    href="https://www.servicemaster.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="footerLink"
                  >
                    <Trans>Privacy Policy</Trans>
                    <VisuallyHidden>
                      <Trans>(opens in a new window)</Trans>
                    </VisuallyHidden>
                    <FontAwesomeIcon
                      icon={faExternalLink}
                      fontSize="0.75em"
                      ml={1}
                    />
                  </Link>
                  {/* <Button
                      variant="footerLink"
                      onClick={() => dispatch(toggleCookieBanner())}
                      fontSize="inherit"
                      p={0}
                      m={0}
                      h="auto"
                    >
                      <Trans>Cookie Settings</Trans>
                    </Button> */}
                  <Link
                    href="https://www.servicemaster.com/accessibility-statement/"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="footerLink"
                  >
                    <Trans>Accessibility Statement</Trans>
                    <VisuallyHidden>
                      <Trans>(opens in a new window)</Trans>
                    </VisuallyHidden>
                    <FontAwesomeIcon
                      icon={faExternalLink}
                      fontSize="0.75em"
                      ml={1}
                    />
                  </Link>
                  <Link
                    href="https://twomenandatruck.com/cookies"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="footerLink"
                  >
                    <Trans>Do Not Sell/Share My Info</Trans>
                    <VisuallyHidden>
                      <Trans>(opens in a new window)</Trans>
                    </VisuallyHidden>
                    <FontAwesomeIcon
                      icon={faExternalLink}
                      fontSize="0.75em"
                      ml={1}
                    />
                  </Link>
                </Text>
              </Box>
              {/* <Box
                w={{ base: '50%', md: '100%' }}
                textAlign={{ base: 'center', md: 'right' }}
                ml="auto"
                mr={{ base: 'auto', md: 0 }}
              >
                <LanguageSwitcher />
              </Box> */}
            </Flex>
          </UlfLayoutContainer>
        </Box>
      </Flex>
    </>
  );
};

export default Footer;
